import Swiper, { Navigation, Pagination, Lazy, Autoplay, Controller } from "swiper";

const swiperStartBg = new Swiper(".swiper--start-bg", {
  modules: [Lazy],
  speed: 800,
  slidesPerView: 1,
  loop: false,
  allowTouchMove: false,
  lazy: {
    enabled: true,
    loadOnTransitionStart: true,
    loadPrevNext: false,
  },
  on: {
    slideChange: function () {
      this.lazy.load();
    },
  },
});
const swiperStart = new Swiper(".swiper--start", {
  modules: [Navigation, Autoplay, Controller],
  speed: 600,
  slidesPerView: 1,
  loop: false,
  allowTouchMove: false,
  navigation: {
    nextEl: ".swiper-nav--next",
    prevEl: ".swiper-nav--prev",
    disabledClass: "is-disabled",
  },
  autoplay: {
    delay: 8000,
    disableOnInteraction: true,
    pauseOnMouseEnter: true,
  },
  controller: {
    control: swiperStartBg,
    by: "slide",
  },
});
